module.exports = __webpack_public_path__ + "img/joseph-and-sons.36fe549d.jpeg";